// extracted by mini-css-extract-plugin
export default {"page":"u1cAQ","header":"qIkfQ","title":"YUOTh","links":"EO0eP","container":"aITA8","inner":"QvOak"};